export const isFullyCovered = (coverage) => coverage === 100;
